"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var styled_components_modifiers_1 = require("styled-components-modifiers");

var styled_components_1 = require("styled-components");

var TextField_1 = __importDefault(require("@material-ui/core/TextField"));

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

var Input_styled_1 = require("./Input.styled");

Object.defineProperty(exports, "modifiers", {
  enumerable: true,
  get: function get() {
    return Input_styled_1.modifiers;
  }
});

var Input = function Input(_ref) {
  var id = _ref.id,
      name = _ref.name,
      value = _ref.value,
      placeholder = _ref.placeholder,
      required = _ref.required,
      onChange = _ref.onChange,
      onKeyPress = _ref.onKeyPress,
      onKeyDown = _ref.onKeyDown,
      onBlur = _ref.onBlur,
      modifiers = _ref.modifiers,
      label = _ref.label,
      type = _ref.type,
      variant = _ref.variant,
      error = _ref.error,
      helperText = _ref.helperText,
      autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      inputMode = _ref.inputMode,
      pattern = _ref.pattern,
      dataNw = _ref.dataNw,
      accept = _ref.accept,
      disabled = _ref.disabled,
      endAdornment = _ref.endAdornment;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: atoms_utils_theme_1.theme
  }, react_1.default.createElement(Input_styled_1.InputStyled, {
    modifiers: modifiers
  }, react_1.default.createElement(TextField_1.default, {
    id: id,
    variant: variant,
    type: type,
    label: label,
    name: name,
    value: value,
    onChange: onChange,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    onBlur: onBlur,
    required: required,
    error: !!error,
    helperText: error || helperText,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    InputProps: {
      inputMode: inputMode,
      pattern: pattern,
      'data-nw': dataNw,
      accept: accept,
      endAdornment: endAdornment
    },
    disabled: disabled
  })));
};

Input.propTypes = {
  id: prop_types_1.default.string,
  name: prop_types_1.default.string,
  value: prop_types_1.default.string,
  label: prop_types_1.default.string,
  onChange: prop_types_1.default.func,
  onBlur: prop_types_1.default.func,
  onKeyPress: prop_types_1.default.func,
  onKeyDown: prop_types_1.default.func,
  type: prop_types_1.default.string,
  error: prop_types_1.default.any,
  helperText: prop_types_1.default.string,
  placeholder: prop_types_1.default.string,
  autoComplete: prop_types_1.default.string,
  inputMode: prop_types_1.default.string,
  pattern: prop_types_1.default.string,
  variant: prop_types_1.default.string,
  required: prop_types_1.default.bool,
  autoFocus: prop_types_1.default.bool,
  modifiers: (0, styled_components_modifiers_1.styleModifierPropTypes)(Input_styled_1.modifiers),
  dataNw: prop_types_1.default.string,
  disabled: prop_types_1.default.bool,
  accept: prop_types_1.default.string,
  endAdornment: prop_types_1.default.any
};
Input.defaultProps = {
  error: null,
  required: false,
  autoFocus: false,
  onKeyPress: null,
  onKeyDown: null,
  disabled: false
};
exports.default = Input;